import { useTranslations } from "next-intl"
import Cards from "./Cards"
import StepsNumbers from "./StepsNumbers"
import ScrollFadeIn from "@/components/shared/animations/ScrollFadeIn"
import ScrollSlideLeft from "@/components/shared/animations/ScrollSlideLeft"
import useCalStore from "@/store/useCalStore"

const YourJourney = () => {
    const t = useTranslations('Home')
    const { handleScheduleClick } = useCalStore()

    return (
        <div className="w-full flex flex-col items-center justify-center gap-10">

            <div className="flex md:gap-10 md:flex-col md:items-center">
                <StepsNumbers />

                <ScrollSlideLeft>
                    <Cards />
                </ScrollSlideLeft>
            </div>

            <ScrollFadeIn>
                <button onClick={() => handleScheduleClick()} className="gradient-button">
                    <span>
                        {t('getStarted')}
                    </span>
                </button>
            </ScrollFadeIn>

        </div>
    )
}

export default YourJourney
